import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import useGetSiteMetadata from '../hooks/useGetSiteMetadata'

export default function InMusic() {
    const { brandName } = useGetSiteMetadata()
    return (
        <Container fluid style={{ background: '#D2D2D2' }}>
            <Container className='py-5'>
                <Row className='align-items-center mb-5'>
                    <Col xs='auto'>
                        <h2 className='fw-bold'>
                            <a href="https://inmusicbrands.com" rel='noreferrer' target='_blank'>
                                <img src='/svg/inmusic-logo-black.svg' alt='' height={40} />
                            </a>
                        </h2>
                    </Col>
                    <Col>
                        <div style={{ height: 1, background: 'black' }} />
                    </Col>
                </Row>
                <Row css={{
                    gap: 100,
                    '@media(max-width: 992px)': { gap: 0 }
                }}>
                    <Col md={6}>
                        <h3
                            className='poppins fw-bold'
                            style={{
                                fontSize: 35,
                                lineHeight: '110%',
                            }}
                        >
                            HOME OF THE WORLD'S PREMIER MUSIC AND AUDIO TECHNOLOGY  BRANDS
                        </h3>
                    </Col>
                    <Col>
                        <p style={{ fontSize: 14, lineHeight: '150%', }}>
                            {brandName} is a member of the premier family of brands known as inMusic committed to pushing the boundaries of innovation in the DJ, music production, live sound, musical instrument, pro audio, and consumer electronics industries, each of inMusic’s brands creates cutting-edge products that incorporate and build upon the latest in engineering, design, and technology.
                        </p>
                        <a
                            href="https://inmusicbrands.com"
                            rel='noreferrer'
                            target='_blank'
                            className='text-uppercase text-black fw-bold text-decoration-none'
                        >
                            Find OUt MORE at INMUSICBRANDS.COM&nbsp;
                            <img src='/svg/arrow-right-icon-black.svg' alt='' />
                        </a>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}